import { isEqual, isNil } from "lodash";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import AuditViewUserTaskList from "../../../common_components/user-task-list/audit-view-user-task-list";
import DocumentManagement from "../../../common_components/document-management/component";
import {
  FG_ALL_AUDIT_VIEWER,
  FG_AUDIT_A_CASE,
  FG_AUDIT_VIEWER,
  hasAnyFeatureGroupAccess,
} from "../../../common_components/user-permissions-helper";
import ExtraFieldTab from "../../../common_components/case-details/extra-fields";
import CaseFields from "../../../common_components/case-details/case-fields";
import { GET_CASE_CLAIM_DETAILS } from "../../../common_components/case-details/services/get-case-claim-details";
import { isManualCase } from "./component";
import { GET_CASE_FIELDS_TAB_REFERENCE_DATA } from "../../../common_components/case-details/services/get-case-fields-tab-reference-data";
import { bindActionCreators } from "redux";
import { actions } from "async-ops";
import EsmdCaseTab from "../../../common_components/case-details/esMd-dashboard";
import { GET_ALIAS_BILL_DATA_FIELDS } from "../../../pages/customer-setup/data-configuration/services/get-alias-bill-data-fields";

const TaskTabPanel: React.FC<any> = (props) => {
  const isTaskTabVisible = useSelector(
    (state) => state["caseDetailReducer"].isTaskTabVisible,
    isEqual
  );
  const caseDetailData = useSelector(
    (state) => state["caseDetailReducer"].caseDetailData,
    isEqual
  );
  const isExternalAuditReadOnly = useSelector(
    (state) => state["auditPropertiesReducer"].isExternalAuditReadOnly,
    isEqual
  );
  const isCaseDetailPopupVisible = useSelector(
    (state: any) => state["caseDetailReducer"].isCaseDetailPopupVisible,
    isEqual
  );
  return isTaskTabVisible ? (
    <div className={isExternalAuditReadOnly ? "mdae-readonly-content" : ""}>
      <AuditViewUserTaskList
        doNotLoadDatasourcesInd={isNil(props.doNotLoadDatasourcesInd)? true : props.doNotLoadDatasourcesInd }
        attachedLevelId={caseDetailData.eaCaseId}
        attachedLevelName={"EAC"}
        includeNonAttachedLevelTasks={true}
        auditGroupId={props.auditGroupId}
        isManagerView={false}
        isCaseDetailPopupVisible={isCaseDetailPopupVisible}
        isFromAuditCaseView={true}
        eaRoundId={props.eaRoundId}
        attachedLevelTitleName={
          caseDetailData?.patientFullName +
          " (" +
          caseDetailData?.patientAcctNo +
          ")"
        }
        myTaskWidgetId={props.caseMyTaskWidgetId}
        myPastDueTaskDrawerId={props.caseMyPastDueTaskDrawerId}
        myThisWeekTaskDrawerId={props.caseMyThisWeekTaskDrawerId}
        myUpcomingTaskDrawerId={props.caseMyUpcomingTaskDrawerId}
        myCompletedTaskDrawerId={props.caseMyCompletedTaskDrawerId}
      />
    </div>
  ) : null;
};

const DocumentManagementTabPanel: React.FC<any> = () => {
  const isDocumentTabVisible = useSelector(
    (state: any) => state["caseDetailReducer"].isDocumentTabVisible,
    isEqual
  );
  const isCaseDetailPopupVisible = useSelector(
    (state: any) => state["caseDetailReducer"].isCaseDetailPopupVisible,
    isEqual
  );
  const isDocumentManagementEnabled = useSelector(
    (state) => state["documentManagementReducer"].isDocumentManagementEnabled,
    isEqual
  );
  const isExternalAuditReadOnly = useSelector(
    (state) => state["auditPropertiesReducer"].isExternalAuditReadOnly,
    isEqual
  );
  const eaCaseId = useSelector(
    (state) => state["caseDetailReducer"].caseDetailData?.eaCaseId,
    isEqual
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const hasAuditViewAccess = useMemo(
    () =>
      hasAnyFeatureGroupAccess(
        [FG_AUDIT_A_CASE, FG_AUDIT_VIEWER, FG_ALL_AUDIT_VIEWER],
        currentUser
      ),
    [currentUser]
  );
  return isDocumentManagementEnabled &&
    isCaseDetailPopupVisible &&
    isDocumentTabVisible ? (
    <div className={isExternalAuditReadOnly ? "mdae-readonly-content" : ""}>
      <DocumentManagement
        hasAuditViewAccess={hasAuditViewAccess}
        isManagerView={false}
        doNotLoadDatasourcesInd={false}
        showForCoderReviewInd={false}
        isBulkDwonloadVisible={true}
        attachedLevelId={eaCaseId}
        attachedLevelName={"EAC"}
        doNotLoadEditDocumentPopup={false}
        isIncludeNonAuditLevelDocumentCheckBoxVisible={true}
        isFromCaseDetails={true}
      />
    </div>
  ) : null;
};

const CaseFieldsTabPanel: React.FC<any> = (props) => {
  const isCaseFieldTabVisible = useSelector(
    (state: any) => state["caseDetailReducer"].isCaseFieldTabVisible,
    isEqual
  );
  const caseDetailData = useSelector(
    (state) => state["caseDetailReducer"].caseDetailData,
    isEqual
  );
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: actions.asyncOperationStart,
    },
    dispatch
  );
  useEffect(() => {
    if (Object.keys(caseDetailData).length > 0 && isCaseFieldTabVisible) {
      asyncAction.asyncOperationStart(
        GET_CASE_CLAIM_DETAILS,
        isManualCase(caseDetailData)
          ? {
              eaCaseId: caseDetailData?.eaCaseId,
              isManualCase: true,
            }
          : {
              caseDetailId: caseDetailData.caseDetailId,
              type: "View",
            }
      );
      if (caseDetailData?.caseDetailId)
        asyncAction.asyncOperationStart(
          GET_CASE_FIELDS_TAB_REFERENCE_DATA,
          caseDetailData?.caseDetailId
        );
    }
  }, [
    caseDetailData.caseDetailId,
    isCaseFieldTabVisible,
    caseDetailData?.eaCaseId,
  ]);
  return isCaseFieldTabVisible ? (
    <CaseFields
      isFromExternalAudit={true}
      isHideBillingHistoryLink={props.isHideBillingHistoryLink}
      isDenialPredictorFlagAvailable={props.isDenialFlagAvailable}
      isCheckBoxVisibleForCharges={props.isCheckBoxVisibleForCharges}
    />
  ) : null;
};
const ExtraFieldsTabPanel: React.FC<any> = () => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: actions.asyncOperationStart,
    },
    dispatch
  );
  const isExtraFieldTabVisible = useSelector(
    (state: any) => state["caseDetailReducer"].isExtraFieldTabVisible,
    isEqual
  );
  const caseDetailData = useSelector(
    (state) => state["caseDetailReducer"].caseDetailData,
    isEqual
    );
    const aliasBillDataFields = useSelector(
        (state: any) => state["caseDetailReducer"].aliasBillDataFields,
        isEqual
    );
  useEffect(() => {
    if (Object.keys(caseDetailData).length > 0 && isExtraFieldTabVisible) {
      asyncAction.asyncOperationStart(
        GET_CASE_CLAIM_DETAILS,
        isManualCase(caseDetailData)
          ? {
              eaCaseId: caseDetailData?.eaCaseId,
              isManualCase: true,
            }
          : {
              caseDetailId: caseDetailData.caseDetailId,
              type: "View",
            }
      );
      if (caseDetailData?.caseDetailId)
        asyncAction.asyncOperationStart(
          GET_CASE_FIELDS_TAB_REFERENCE_DATA,
          caseDetailData?.caseDetailId
        );
      }
      asyncAction.asyncOperationStart(GET_ALIAS_BILL_DATA_FIELDS);
  }, [
    caseDetailData.caseDetailId,
    isExtraFieldTabVisible,
    caseDetailData?.eaCaseId,
  ]);
  return isExtraFieldTabVisible ? <ExtraFieldTab></ExtraFieldTab> : null;
};

const EsmdTabPanel: React.FC<any> = (props) => {
  const isEsmdDashboardTabVisible = useSelector(
    (state) => state["caseDetailReducer"].isEsmdDashboardTabVisible,
    isEqual
  );
  const isExternalAuditReadOnly = useSelector(
    (state) => state["auditPropertiesReducer"].isExternalAuditReadOnly,
    isEqual
  );
  return isEsmdDashboardTabVisible ? (
    <div
      className={
        isExternalAuditReadOnly
          ? "mdae-readonly-content esmd-submission-tab-container"
          : "esmd-submission-tab-container"
      }
    >
      <EsmdCaseTab />
    </div>
  ) : null;
};

export {
  TaskTabPanel,
  DocumentManagementTabPanel,
  ExtraFieldsTabPanel,
  CaseFieldsTabPanel,
  EsmdTabPanel,
};
